import {Color} from "../../types";
import Spinner from "../../../../ui-components/Spinner";
import {FormattedMessage} from "react-intl";

type ColorSquareProps = {
  color: Record<string, any> | null | undefined | string;
  colors?: Color[];
}

export const ColorSquare = ({
  color,
  colors
}: ColorSquareProps) => {
  // CASE 1: colors are not loaded yet --> render a spinner
  if (!colors?.length)
    return (
      <div className="relative w-full h-10 text-center">
        {/* @ts-ignore */}
        <Spinner styleType="white"/>
      </div>
    );
  // CASE 3: no color --> render "undefined" label
  if (!color)
    return <FormattedMessage id="undefined" defaultMessage="undefined"/>;
  // CASE 4: color is defined --> render color block and code (black with "-" label if color is not found)
  const colorInfo = colors?.find((c) => c.code === color);
  return <div className="flex items-center gap-2">
    <div className="w-5" style={{
      border: '1px solid #000000',
      backgroundColor: `rgb(${(colorInfo?.rgb ?? [0, 0, 0]).join(', ')})`,
      aspectRatio: '1 / 1'
    }}/>
    <span className={"font-semibold leading-none -mt-0.5"}>{colorInfo?.code ?? "-"}</span>
  </div>
}